document.addEventListener('DOMContentLoaded', function() {
  // Lazy load background images
  const lazyBackgrounds = document.querySelectorAll('[data-bg-src]');
  
  if ('IntersectionObserver' in window) {
    const backgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const target = entry.target;
          const srcset = target.getAttribute('data-bg-srcset');
          const src = target.getAttribute('data-bg-src');
          
          // Find the appropriate image size based on screen width
          if (srcset) {
            const sources = srcset.split(',').map(s => {
              const [url, width] = s.trim().split(' ');
              return { url, width: parseInt(width) };
            });
            
            // Sort by width ascending
            sources.sort((a, b) => a.width - b.width);
            
            // Find appropriate size for current viewport
            const containerWidth = target.offsetWidth * window.devicePixelRatio;
            let selectedSource = sources[0].url;
            
            for (const source of sources) {
              if (source.width >= containerWidth) {
                selectedSource = source.url;
                break;
              }
              // If we're at the last item, use it regardless
              selectedSource = source.url;
            }
            
            target.style.backgroundImage = `url('${selectedSource}')`;
          } else if (src) {
            target.style.backgroundImage = `url('${src}')`;
          }
          
          backgroundObserver.unobserve(target);
        }
      });
    }, {
      rootMargin: '200px' // Start loading when within 200px of viewport
    });
    
    lazyBackgrounds.forEach(function(lazyBackground) {
      backgroundObserver.observe(lazyBackground);
    });
  } 
  else {
    // Fallback for browsers that don't support IntersectionObserver
    lazyBackgrounds.forEach(function(lazyBackground) {
      const src = lazyBackground.getAttribute('data-bg-src');
      if (src) {
        lazyBackground.style.backgroundImage = `url('${src}')`;
      }
    });
  }
});